import { Field } from 'formik';
import { Box, useMediaQuery } from '@chakra-ui/react';
import ElementInstructions from '../components/ElementInstructions';
import ElementHeading from '../components/ElementHeading';
import ElementErrorMessage from '../components/ElementErrorMessage';
import SkillsBox from './components/SkillsBox.js';
import SelectBox from './components/SelectBox';
import SkillsBoxPhone from './components/SkillsBoxPhone';
import AdvancedSearchBox from './components/AdvancedSearchBox';

const Expertise = ({ industry, qObj, fieldName, props }) => {

  const isDesktop = useMediaQuery('(min-width: 768px)', {ssr:false})[0];

  const style = props.stateProps.expertiseStyles;
  const resumeIndex = props.stateProps.sectionData.resumeIndex;
  const resume = props.stateProps.dataToSave.saved.resumes[resumeIndex];
  const savedIndustry = props.stateProps.dataToSave.saved.resumes[resumeIndex].industry;
  if(savedIndustry[0] === industry.slug) {
    qObj.options = [];
  }
  //setOptions(props,qObj,props.stateProps.sectionData.sectionIndex);
  if(resume.expertiseData !== undefined) {
    qObj.options = resume.expertiseData.options;
  } else {
    qObj.options = [];
  }

  if (typeof props.formikProps.values.jobSeekerData[0]['TSQ5'] === 'undefined') {
    props.formikProps.values.jobSeekerData[0]['TSQ5'] = [];
  }
  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        /*************JB**********/
        const selected = props.formikProps.values.jobSeekerData[0]['TSQ5'];
        /*************JB**********/
        let val = field.value;
        return (
          <>
            <ElementHeading qObj={qObj} props={props} />
            <ElementInstructions instructions={qObj.instructions} />
            <Box sx={{ ...style.phone.margins }}>
                <Box sx={{ ...style.phone.stickyBox }}>
                  {!isDesktop && (
                    <SkillsBoxPhone props={props} qObj={qObj} selectedSkills={selected} style={style}/>
                  )}
                </Box>

              <Box>
                <AdvancedSearchBox props={props} qObj={qObj} />
                <SelectBox props={props} qObj={qObj} val={val} style={style} />
              </Box>
            </Box>
            <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
            {isDesktop && (
              <SkillsBox props={props} qObj={qObj} selectedSkills={selected} style={style} />

            )}
          </>
        );
      }}
    </Field>
  );
};
export default Expertise;
